"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldDisableByContractType = void 0;
const types_1 = require("@framework/types");
const shouldDisableByContractType = (contract) => {
    const { contractFeatures, contractStatus, contractType } = contract;
    if (contractType === types_1.TokenType.NATIVE) {
        return true;
    }
    if (contractFeatures.includes(types_1.ContractFeatures.EXTERNAL)) {
        return true;
    }
    return contractStatus === types_1.ContractStatus.INACTIVE;
};
exports.shouldDisableByContractType = shouldDisableByContractType;
//# sourceMappingURL=should-disable-by-contract-type.js.map